import React from 'react'
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDYl5jC1bg1eZRugTWJdW-QpBSxbun9YYw",
  authDomain: "smart-id-ae558.firebaseapp.com",
  projectId: "smart-id-ae558",
  storageBucket: "smart-id-ae558.firebasestorage.app",
  messagingSenderId: "239663068509",
  appId: "1:239663068509:web:40183458be14f2efbca4b4",
  measurementId: "G-RV28XTMRFH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const provider = new GoogleAuthProvider();

export { auth, db, provider };
